import React from 'react';
import { motion } from 'framer-motion';
import { Thermometer, Moon, Activity, DollarSign } from 'lucide-react';
const problems = [{
  icon: Thermometer,
  text: "Kids bring home colds every month—missed work, $50 co-pays, antibiotics that don't work on viruses"
}, {
  icon: Moon,
  text: 'Your own sleep issues cost $800/year in supplements that do nothing'
}, {
  icon: Activity,
  text: "Spouse's joint pain or migraines kill family weekends"
}, {
  icon: DollarSign,
  text: 'Grocery bill up 30%, pharmacy bill up 50%—but health gets worse'
}];
export function ProblemSection() {
  return <section className="py-20 bg-[#f4f7f5]" data-id="element-143">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a3c2a] mb-4" data-id="element-146">
            The Daily Health Grind Busy Parents Face
          </h2>
          <div className="w-24 h-1 bg-[#c9a84c] mx-auto rounded-full" data-id="element-147" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-148">
          {problems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-[#1a3c2a]/5 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-149">
              <div className="bg-[#fff9e6] p-3 rounded-full shrink-0" data-id="element-150">
                <item.icon className="w-6 h-6 text-[#c9a84c]" data-id="element-151" />
              </div>
              <p className="text-[#5c4a32] text-lg leading-relaxed" data-id="element-152">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center max-w-3xl mx-auto" data-id="element-153">
          <p className="text-xl font-medium text-[#1a3c2a]" data-id="element-154">
            Your medicine cabinet fails because it's reactive, not proactive.{' '}
            <br className="hidden md:block" data-id="element-155" />
            <span className="text-[#c9a84c]" data-id="element-156">
              No system. No kitchen power. Endless spending.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}